import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Container, SwitchButton, Label, Wrap } from './toggle-switch-style'
import * as BaseFunctions from '../input/base-functions'
import { useInitialValueToValidation } from '@components/input/custom-hooks'

const ToggleSwitch = ({
  id,
  name,
  disabled,
  label,
  onFieldValidation,
  customLabel,
  required,
  checked,
  onBlur,
  onClick,
  onChange,
  tabIndex,
  ariaLabel,
  className,
}) => {
  const [isChecked, setIsChecked] = useState(checked)

  const handlerOnChange = async ({ target: { checked, name } }) => {
    setIsChecked(checked)
    await BaseFunctions.handlerOnFieldValidation(onFieldValidation, name, !checked && required)

    if (onChange) onChange({ checked, name })
  }

  const handlerOnClick = async () => {
    if (onClick) onClick()
  }

  useEffect(() => {
    const hasError = required && !checked
    BaseFunctions.handlerOnFieldValidation(onFieldValidation, name, hasError)
  }, [])

  return (
    <Wrap className={className}>
      <Container>
        <Checkbox
          type="checkbox"
          aria-pressed={isChecked}
          id={id}
          name={name || id}
          role="button"
          disabled={disabled}
          required={required}
          checked={isChecked}
          onClick={handlerOnClick}
          onChange={handlerOnChange}
          onBlur={onBlur}
          aria-label={ariaLabel}
          tabIndex={tabIndex || 0}
        />
        <SwitchButton aria-hidden="true" />
      </Container>
      <Label role="label">
        {label || customLabel}
        {required && '*'}
      </Label>
    </Wrap>
  )
}
ToggleSwitch.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  customLabel: PropTypes.object,
  required: PropTypes.bool,
  checked: PropTypes.bool,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  tabIndex: PropTypes.number,
  ariaLabel: PropTypes.string,
  onFieldValidation: PropTypes.func,
  className: PropTypes.string,
}
ToggleSwitch.displayName = 'ToggleSwitch'

export default ToggleSwitch
